import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useSearchBox } from 'react-instantsearch';
import { t } from 'react-switch-lang';
import { scrollToTop } from '../../utils/Accessibility';

export default function CustomSearchBox({ initialQuery }) {
  const router = useRouter();
  const { refine, query: lastQuery } = useSearchBox();
  const [inputValue, setInputValue] = useState(lastQuery);
  const timeoutRef = useRef(null);

  const handleQueryWithDebounce = useCallback((query) => {
    const trimmedQuery = query.trim();
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      refine(trimmedQuery);
      if (router.query.landingPageKey) return; // don't change the url on filtered search pages
      router.replace(`/partner-search/${encodeURIComponent(trimmedQuery)}`, undefined, { shallow: true });
    }, 200);
  }, [refine, router]);

  useEffect(() => {
    setInputValue(initialQuery);
    scrollToTop();
  }, [initialQuery]);

  useEffect(() => {
    if (lastQuery === '') setInputValue('');
  }, [lastQuery]);

  return (
    <InputGroup className="mb-3 d-flex justify-content-center">
      <Form.Control
        placeholder={t('PaymentProcess_Search_PlaceHolder')}
        aria-label={t('PaymentProcess_Search_Prompt')}
        type="search"
        inputMode="search"
        value={inputValue}
        onChange={(event) => {
          const { value } = event.currentTarget;
          setInputValue(value);
          handleQueryWithDebounce(value);
        }}
        style={{ maxWidth: '40rem' }}
      />
    </InputGroup>
  );
}
